const { IS_NNORMAL } = require('./constants');

const baseTranslations = {
  target: {
    // Respetar siempre el orden Hombre, Mujer, niños
    es: [ 'hombre', 'mujer', 'kids', 'goods', 'all' ],
    mx: [ 'hombre', 'mujer', 'kids', 'goods', 'all' ],
    en: [ 'men', 'women', 'kids', 'goods', 'all' ],
    fr: [ 'homme', 'femme', 'enfant', 'goods', 'all' ],
    de: [ 'herren', 'damen', 'kinder', 'goods', 'all' ],
    it: [ 'uomo', 'donna', 'bambino', 'goods', 'all' ],
  },
  product: {
    es: [ 'zapatos', 'bolsos-accesorios', 'ropa', 'campergoods', 'all' ],
    mx: [ 'zapatos', 'bolsos-accesorios', 'ropa', 'campergoods', 'all' ],
    en: [ 'shoes', 'bags-accessories', 'apparel', 'campergoods', 'all' ],
    fr: [ 'chaussures', 'sacs-accessoires', 'vetement', 'campergoods', 'all' ],
    de: [ 'schuhe', 'taschen-accessoires', 'kleidung', 'campergoods', 'all' ],
    it: [ 'scarpe', 'borse-accesori', 'abbigliamento', 'campergoods', 'all' ],
  },
};

// Lista de países
const nnormalCountries = [ 'ES' ];
const camperCountries = [
  'AD',
  'AE',
  'AL',
  'AR',
  'AT',
  'AU',
  'BA',
  'BD',
  'BE',
  'BG',
  'BH',
  'BM',
  'BO',
  'BR',
  'BS',
  'BW',
  'CA',
  'CH',
  'CL',
  'CN',
  'CO',
  'CR',
  'CY',
  'CZ',
  'DE',
  'DK',
  'DO',
  'EC',
  'EE',
  'EG',
  'ES',
  'ET',
  'FI',
  'FR',
  'GB',
  'GR',
  'GT',
  'HK',
  'HN',
  'HR',
  'HU',
  'ID',
  'IE',
  'IL',
  'IN',
  'IS',
  'IT',
  'JM',
  'JO',
  'JP',
  'KE',
  'KH',
  'KR',
  'KW',
  'KY',
  'LB',
  'LI',
  'LK',
  'LT',
  'LU',
  'LV',
  'MA',
  'MC',
  'MD',
  'MT',
  'MX',
  'MY',
  'NA',
  'NG',
  'NI',
  'NL',
  'NO',
  'NZ',
  'OM',
  'PA',
  'PE',
  'PH',
  'PL',
  'PT',
  'PY',
  'RO',
  'RU',
  'SA',
  'SE',
  'SG',
  'SI',
  'SK',
  'SN',
  'SV',
  'TH',
  'TR',
  'TW',
  'TZ',
  'US',
  'VE',
  'VN',
  'ZA',
];
const countries = IS_NNORMAL ? nnormalCountries : camperCountries;

// Lista de idiomas
const nnormalLanguages = [ 'es' ];

const camperLanguages = [
  'es',
  'br',
  'ca',
  'cl',
  'cn',
  'co',
  'de',
  'el',
  'en',
  'fr',
  'it',
  'ja',
  'ko',
  'mx',
  'nl',
  'pl',
  'pt',
  'ru',
  'th',
  'tr',
  'zh',
];
const languages = IS_NNORMAL ? nnormalLanguages : camperLanguages;

// Checked ISO codes here: https://www.iso.org/obp/ui/#search
const nnormalISO = {
  AD: [ 'ca', 'en', 'es' ], // Andorra
  AE: [ 'en' ],
  AL: [ 'en' ], // Albania
  AR: [ 'en', 'es' ],
  AT: [ 'en', 'de' ], // Austria
  AU: [ 'en' ],
  BA: [ 'en' ], // Bosnia and Herzegovina
  BE: [ 'fr', 'en', 'de' ], // Belgium
  BG: [ 'en' ], // Bulgaria
  BH: [ 'en' ],
  BM: [ 'en' ],
  BR: [ 'en', 'pt' ],
  BS: [ 'en' ],
  BW: [ 'en' ],
  CA: [ 'en', 'fr' ], // Canada
  CH: [ 'fr', 'en', 'it', 'de' ], // Switzerland
  CN: [ 'en' ],
  CR: [ 'en', 'es' ],
  CY: [ 'en' ], // Cyprus
  CZ: [ 'en' ], // Czech Republic
  DE: [ 'en', 'de' ], // Germany
  DK: [ 'en' ], // Denmark
  DO: [ 'en', 'es' ],
  DZ: [ 'en', 'fr' ],
  EC: [ 'en', 'es' ],
  EE: [ 'en' ], // Estonia
  EG: [ 'en' ],
  ES: [ 'es', 'ca', 'en' ], // Spain
  ET: [ 'en' ],
  FI: [ 'en' ], // Finland
  FR: [ 'fr', 'en' ], // France
  GB: [ 'en' ], // United Kingdom
  GR: [ 'en' ], // Greece
  HK: [ 'en' ],
  HN: [ 'en', 'es' ],
  HR: [ 'en' ], // Croatia
  HU: [ 'en' ], // Hungary
  ID: [ 'en' ], // Ireland
  IE: [ 'en' ], // Ireland
  IL: [ 'en' ],
  IN: [ 'en' ],
  IS: [ 'en' ], // Iceland
  IT: [ 'en', 'it' ], // Italy
  JM: [ 'en' ],
  JP: [ 'en', 'ja' ],
  KE: [ 'en' ],
  KH: [ 'en' ],
  KR: [ 'en', 'ko' ], // Korea
  KW: [ 'en' ],
  LB: [ 'en', 'fr' ],
  LI: [ 'en' ], // Liechtenstein
  LK: [ 'en' ],
  LT: [ 'en' ], // Lithuania
  LU: [ 'fr', 'en', 'de' ], // Luxembourg
  LV: [ 'en' ], // Latvia
  MA: [ 'en', 'fr' ],
  MC: [ 'en', 'fr' ], // Monaco
  MD: [ 'en' ],
  MX: [ 'en', 'es' ],
  MY: [ 'en' ],
  NG: [ 'en' ],
  NL: [ 'en' ], // Netherlands
  NO: [ 'en' ], // Norway
  NZ: [ 'en' ], // New Zealand
  OM: [ 'en' ],
  PA: [ 'en', 'es' ],
  PH: [ 'en' ],
  PL: [ 'en' ], // Poland
  PT: [ 'en' ], // Portugal
  QA: [ 'en' ],
  RO: [ 'en' ], // Romania
  RS: [ 'en' ],
  SA: [ 'en' ],
  SE: [ 'en' ], // Sweden
  SG: [ 'en' ],
  SI: [ 'en' ], // Slovenia
  SK: [ 'en' ], // Slovakia
  SN: [ 'en', 'fr' ],
  TH: [ 'en' ],
  TR: [ 'en' ],
  TW: [ 'en' ],
  US: [ 'en', 'es' ], // United States
  VN: [ 'en' ],
  ZA: [ 'en' ],
};

function getI18nISO(isoObject) {
  const entries = Object.entries(isoObject);
  if (!entries.length) {
    throw new Error('No ISO entries found');
  }
  return entries.reduce((acc, [ country, langs ]) => {
    langs.forEach((lang) => acc.push(`${lang}_${country}`));
    return acc;
  }
  , []);
}
const nnormalISOLanguages = getI18nISO(nnormalISO);
// TODO: por ahora hardcoded. Habra que sacarlos de los servicios de camper en el futuro
// De aquí pueden salir combinaciones no válidas como 'it_ES', pero es lo que queremos.
// Si el locale del usuario no es válido, se le redirigirá al idioma por defecto del país.
const camperIsoLanguages = [
  'ca_AD',
  'en_AD',
  'es_AD',
  'en_AE',
  'en_AL',
  'en_AR',
  'es_AR',
  'de_AT',
  'en_AT',
  'en_AU',
  'en_BA',
  'en_BD',
  'de_BE',
  'en_BE',
  'fr_BE',
  'nl_BE',
  'en_BG',
  'en_BH',
  'en_BM',
  'en_BN',
  'en_BO',
  'es_BO',
  'en_BR',
  'pt_BR',
  'en_BS',
  'en_BW',
  'en_CA',
  'fr_CA',
  'de_CH',
  'en_CH',
  'fr_CH',
  'it_CH',
  'cl_CL',
  'en_CL',
  'en_CN',
  'zh_CN',
  'co_CO',
  'en_CO',
  'en_CR',
  'es_CR',
  'en_CY',
  'en_CZ',
  'de_DE',
  'en_DE',
  'en_DK',
  'en_DO',
  'es_DO',
  'en_DZ',
  'fr_DZ',
  'en_EC',
  'es_EC',
  'en_EE',
  'en_EG',
  'ca_ES',
  'en_ES',
  'es_ES',
  'en_ET',
  'es_ET',
  'en_FI',
  'en_FR',
  'fr_FR',
  'en_GB',
  'el_GR',
  'en_GR',
  'en_GT',
  'es_GT',
  'en_HK',
  'en_HN',
  'es_HN',
  'en_HR',
  'en_HU',
  'en_ID',
  'en_IE',
  'en_IL',
  'en_IN',
  'en_IS',
  'en_IT',
  'it_IT',
  'en_JM',
  'en_JO',
  'en_JP',
  'ja_JP',
  'en_KE',
  'en_KH',
  'en_KR',
  'ko_KR',
  'en_KW',
  'en_KY',
  'en_LB',
  'fr_LB',
  'en_LI',
  'en_LK',
  'en_LT',
  'de_LU',
  'en_LU',
  'fr_LU',
  'en_LV',
  'en_MA',
  'fr_MA',
  'en_MC',
  'fr_MC',
  'en_MD',
  'en_MT',
  'en_MX',
  'mx_MX',
  'en_MY',
  'en_NA',
  'en_NG',
  'en_NI',
  'es_NI',
  'en_NL',
  'nl_NL',
  'en_NO',
  'en_NZ',
  'en_OM',
  'en_PA',
  'es_PA',
  'en_PE',
  'es_PE',
  'en_PG',
  'en_PH',
  'en_PL',
  'pl_PL',
  'en_PT',
  'pt_PT',
  'en_PY',
  'es_PY',
  'en_QA',
  'en_RO',
  'en_RS',
  'sr_RS',
  'en_RU',
  'ru_RU',
  'en_SA',
  'en_SE',
  'en_SG',
  'en_SI',
  'en_SK',
  'en_SN',
  'fr_SN',
  'en_SV',
  'es_SV',
  'en_TH',
  'th_TH',
  'en_TR',
  'tr_TR',
  'cn_TW',
  'en_TW',
  'en_TZ',
  'en_US',
  'es_US',
  'en_VE',
  'es_VE',
  'en_VN',
  'en_ZA',
  'en_XI', // irlanda del norte
];
const isoLanguages = IS_NNORMAL ? nnormalISOLanguages : camperIsoLanguages;
// const isoLanguages = IS_NNORMAL ? [ 'es_ES', 'en_ES' ] : camperIsoLanguages;
/* countries.forEach((country) => {
  languages.forEach((language) => {
    isoLanguages.push(`${language}_${country}`);
  });
}); */

const countryMapper = {
  EU: [ 'DE', 'ES', 'LI', 'CH', 'CA' ],
  US: [ 'US', 'AU' ],
  UK: [ 'UK' ],
  GB: [ 'GB' ],
  JP: [ 'JP' ],
  KR: [ 'KR' ],
  MX: [ 'MX' ],
  RU: [ 'RU' ],
};

/**
 * @function getBaseTransations
 * @description Returns translations for target and product
 * @param {string} langCode ISO code of region (es_ES) or generic iso code (es)
 * @param {string} key key of the translation: Current: 'target', 'product'
 * @returns {string}
 */
function getBaseTranslations(langCode, key) {
  // intentamos buscar por codigo iso - region => e.g: es_ES
  // sino intentamos buscar por codigo iso - generico => e.g: es
  // sino devolvemos idioma por defecto => e.g: en
  if (Object.keys(baseTranslations).includes(key)) {
    if (Object.keys(baseTranslations[key]).includes(langCode)) {
      return JSON.parse(JSON.stringify(baseTranslations[key][langCode]));
    }
    if (langCode.includes('_') && Object.keys(baseTranslations[key]).includes(langCode.split('_')[0])) {
      return JSON.parse(JSON.stringify(baseTranslations[key][langCode.split('_')[0]]));
    }
    return JSON.parse(JSON.stringify(baseTranslations[key].es));
  }
  return Error('Provided key not in base translations');
}

function getCountryFromMarket(market) {
  const countryCode = Object.keys(countryMapper).filter((country) => countryMapper[country].includes(market));
  if (countryCode.length) {
    return countryCode[0];
  }
  return 'EU';
}

module.exports = {
  baseTranslations,
  getCountryFromMarket,
  getBaseTranslations,
  countryMapper,
  isoLanguages,
  getI18nISO,
};
